import React from "react";
import { PaginationProps } from "antd";
import { DropdownProps } from "ui/Dropdown";
import Dropdown from "ui/Dropdown";
import FlexContainer from "ui/FlexContainer";
import { Text } from "ui/Text";
import {
  Container,
  Pagination as PaginationStyle,
  NextLink,
  PrevLink,
  FirstLink,
  LastLink,
} from "./_paginationStyle";

type Props = PaginationProps & {
  onLastPage?: () => void;
  onFirstPage?: () => void;
  currentPage?: number;
  totalCount?: number;
  pageSizeDropdownProps?: DropdownProps;
  pageSizeTextLeft?: string;
  pageSizeTextRight?: string;
  withEndLink?: boolean;
  onChange?: (page: number) => void;
  containerClassName?: string;
};

function Pagination(props: Props) {
  const {
    pageSize,
    currentPage,
    totalCount,
    onLastPage,
    onFirstPage,
    pageSizeDropdownProps,
    pageSizeTextLeft,
    pageSizeTextRight,
    withEndLink = true,
    containerClassName = "",
    ...rest
  } = props;

  const itemRender = (page: number, type: string, originalEl: Element) => {
    if (type === "prev") return <PrevLink />;
    if (type === "next") return <NextLink />;

    return originalEl;
  };

  return (
    <Container
      justifyContent={pageSizeDropdownProps ? "space-between" : "center"}
      className={containerClassName}>
      <FlexContainer className="pagination-container" alignItems="center" width="fit-content">
        {withEndLink && <FirstLink disabled={currentPage === 1} onClick={onFirstPage} />}
        <PaginationStyle
          current={currentPage}
          total={totalCount}
          itemRender={itemRender}
          showSizeChanger={false}
          pageSize={pageSize}
          {...rest}
        />
        {withEndLink && (
          <LastLink
            disabled={totalCount && pageSize && currentPage === Math.ceil(totalCount / pageSize)}
            onClick={onLastPage}
          />
        )}
      </FlexContainer>
      {pageSizeDropdownProps && (
        <FlexContainer gap={8} alignItems="center" width="auto" flexWrap={false} flexShrink="0">
          <Text>{pageSizeTextLeft}</Text>
          <Dropdown
            alignment="top"
            showSelected
            padding="8px 16px"
            optionAutoWidth
            {...pageSizeDropdownProps}
          />
          <Text>{pageSizeTextRight}</Text>
        </FlexContainer>
      )}
    </Container>
  );
}

Pagination.defaultProps = {
  pageSize: 0,
  currentPage: 1,
  totalCount: 0,
};

export default Pagination;
